export const CErrorSummaries = {
    DEFAULT: 'Error',
    TIME_OUT: 'Time Out'
} as const;